// Label Bahasa Indonesia untuk kode dari API admin.
import type { AdminActionCode, AdminMenuCode } from '@folaplus/contracts';

export const MENU_LABEL: Record<AdminMenuCode, string> = {
  DASHBOARD: 'Dashboard',
  MEMBERS: 'Member & pohon',
  CONFIG_MEMBERSHIP: 'Konfigurasi membership',
  CONFIG_TIER: 'Konfigurasi tier',
  CONFIG_INCENTIVE: 'Konfigurasi insentif',
  CONFIG_ACCOUNT_WALLET: 'Konfigurasi wallet & akun',
  CONFIG_PAYMENT_TAX: 'Konfigurasi pembayaran & pajak',
  PLATFORMS: 'Integrasi platform',
  SHOPPING_ORDERS: 'Transaksi belanja',
  PACKAGE_ORDERS: 'Transaksi paket',
  WALLET_LEDGER: 'Wallet & ledger',
  WITHDRAWALS: 'Pencairan',
  FINANCE: 'Keuangan',
  TAX: 'Pajak',
  REPORTS: 'Laporan',
  AUDIT_LOGS: 'Audit log',
  ADMIN_ROLES: 'Admin & role',
};

export const ACTION_LABEL: Record<AdminActionCode, string> = {
  CREATE: 'Create',
  READ: 'Read',
  UPDATE: 'Update',
  DELETE: 'Delete',
  EXPORT: 'Export',
};

export const CLASS_LABEL: Record<string, string> = { GENERAL: 'General', PNM: 'PNM', SHOPPER: 'Shopper' };

export const COMPONENT_LABEL: Record<string, string> = {
  CASHBACK: 'Cashback',
  ADDITIONAL_CASHBACK: 'Cashback tambahan',
  DIRECT_NON_MEMBER: 'Direct (non-member)',
  DIRECT_RECRUITEE: 'Direct (rekrutan)',
  INDIRECT_RECRUITEE: 'Indirect (rekrutan)',
  MEMBERSHIP_DIRECT: 'Membership direct',
  MEMBERSHIP_INDIRECT: 'Membership indirect',
};

export const POSITION_LABEL: Record<string, string> = {
  BUYER: 'Pembeli',
  UPLINE_L1: 'Upline L1',
  UPLINE_L2: 'Upline L2',
};

export const STATUS_LABEL: Record<string, string> = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  RETURNED: 'Returned',
  RELEASED: 'Released',
  VOID: 'Void',
  EXPIRED: 'Expired',
  REINSTATED: 'Reinstated',
  PAID: 'Paid',
  FAILED: 'Failed',
  REQUESTED: 'Requested',
  PROCESSING: 'Processing',
  SUCCESS: 'Success',
  ACTIVE: 'Aktif',
  SUSPENDED: 'Suspended',
  PENDING_PAYMENT: 'Menunggu bayar',
  MATCHED: 'Matched',
  MISMATCH: 'Mismatch',
  QUEUED: 'Antre',
  RUNNING: 'Berjalan',
  DONE: 'Selesai',
  ATTRIBUTED: 'Teratribusi',
  UNATTRIBUTED: 'Tidak teratribusi',
  DRAFT: 'Draft',
  ISSUED: 'Diterbitkan',
  AMENDED: 'Pembetulan',
};

/** Status bukti potong PPh 21 (PRD v1.3 bagian 9). */
export const SLIP_STATUS_LABEL: Record<string, string> = {
  DRAFT: 'Draft',
  ISSUED: 'Diterbitkan',
  AMENDED: 'Pembetulan',
  CANCELLED: 'Dibatalkan',
};

export const PPH_MODE_LABEL: Record<string, string> = {
  COMPANY_BORNE: 'Ditanggung perusahaan',
  WITHHELD: 'Dipotong dari member',
};

export const CONFIG_CATEGORY_LABEL: Record<string, string> = {
  MEMBERSHIP: 'Membership',
  TIER: 'Tier',
  INCENTIVE: 'Insentif',
  ACCOUNT_WALLET: 'Wallet & akun',
  PAYMENT: 'Pembayaran',
  TAX: 'Pajak',
  PLATFORM: 'Mapping status platform',
};

export const PACKAGE_KIND_LABEL: Record<string, string> = {
  ACTIVATION: 'Aktivasi pohon',
  UPGRADE: 'Upgrade Shopper',
};
